import { httpApi } from '@api/http.api';
import type {
    CommonTablePaginatedResponse,
    CommonTableRequest,
} from '@routes/sidebar/admin-center/___shared___/types.ts';

export type FuelTypesRequest = CommonTableRequest;

export interface FuelType {
    id: number;
    name: string | null;
    code: string | null;
    fuelTypeCategoryId: number | null;
    fuelTypeCategoryName: string | null;
    isBuiltIn: boolean;
    isActive: boolean;
    createdAtUTC: string;
    updatedAtUTC: string;
}

export interface ResultsDescription {
    [k: string]: unknown;
}

export interface FuelTypesResponse {
    data: FuelType[];
    pagination: CommonTablePaginatedResponse;
    resultsDescription: ResultsDescription;
}

export interface CreateFuelTypeRequest {
    name: string;
    code: string;
    fuelTypeCategoryId: number;
}

export type UpdateFuelTypeRequest = CreateFuelTypeRequest;

export const getApiFuelTypes = (
    clientId: number,
    tenantAlias: string,
    payload: FuelTypesRequest,
): Promise<FuelTypesResponse> =>
    httpApi
        .post<FuelTypesResponse>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/fuel-types/search`, payload)
        .then(({ data }) => data);

export const createApiFuelType = (
    clientId: number,
    tenantAlias: string,
    payload: CreateFuelTypeRequest,
): Promise<FuelType> =>
    httpApi
        .post<FuelType>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/fuel-types`, payload)
        .then(({ data }) => data);

export const updateApiFuelType = (
    clientId: number,
    tenantAlias: string,
    id: number,
    payload: UpdateFuelTypeRequest,
): Promise<FuelType> =>
    httpApi
        .put<FuelType>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/fuel-types/${id}`, payload)
        .then(({ data }) => data);

export const deleteApiFuelType = (clientId: number, tenantAlias: string, id: number): Promise<FuelType> =>
    httpApi
        .delete<FuelType>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/fuel-types/${id}`)
        .then(({ data }) => data);
